import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class NfoPurchaseUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getNfoPurchaseDetails(data);
    }
}
export default NfoPurchaseUseCase;
